import {Box, withStyles} from "@material-ui/core";

export default withStyles({
    root: {
        marginBottom: 20,
        '&:last-of-type': {
            marginBottom: 0
        }
    }
})(Box)